class CheckBodyScroll {

    init (threshold = 200) {
        this.threshold = threshold;
        window.addEventListener('scroll', this.check.bind(this));
    }

    check()
    {

        let body = document.body;
        let html = document.documentElement;

        let scroll = Math.max(body.scrollTop, html.scrollTop);
        let classname = 'has-scrolled';

        if (scroll > this.threshold && !body.classList.contains(classname)) {
            body.classList.add(classname);
            return;
        }

        if (scroll < this.threshold && body.classList.contains(classname)) {
            body.classList.remove(classname);
            return;
        }
    }
}

export default new CheckBodyScroll();